import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

// Routes
/* El criterio a seguir es que si existen mas de 2 rutas relacionadas entre si ejemplo Works List y Works Profile deben agruparse en un archivo separado */
import Calendar from "./calendar.routes";
import EquipmentProfile from "./equipmentProfile.routes";
import New from "./new.routes";
import Stocks from "./stocks.routes";
import Users from "./users.routes";
import Tickets from "./tickets.routes";
import Works from "./works.routes";
Vue.use(Router);

const routerOptions = [
  ...Calendar,
  ...EquipmentProfile,
  ...New,
  ...Stocks,
  ...Users,
  ...Tickets,
  ...Works,
  { path: "*", redirect: { name: "AssetsModule" } },
  {
    path: "/assets",
    name: "AssetsModule"
  },
  {
    path: "/area-list",
    name: "AreaList",

    beforeEnter: (to, from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "Dashboard",
    path: "/"
  },
  {
    name: "EmailVerified",
    path: "/email-verified"
  },
  {
    name: "Error",
    path: "/error",
    meta: {
      layout: "error"
    }
  },
  {
    name: "InspectionProfile",
    path: "/inspections/:id"
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      layout: "auth"
    }
  },

  {
    path: "/register",
    name: "Register",
    beforeEnter: (to, from, next) => {
      // Siene rango de admin ++
      if (store.getters["auth/adminAndUp"]) {
        next();
        return;
        //Redirecciona al Dashboard
      } else next({ path: "/error" });
    }
  },
  {
    name: "ReliabilityProfile",
    path: "/reliability/:id"
  },
  {
    name: "RepairLogsProfile",
    path: "/repair-profile/:id"
  }
];
const routes = routerOptions.map(r => {
  return {
    ...r,
    component: () =>
      import(/* webpackChunkName: "[request]" */ `@/views/${r.name}/Index.vue`)
  };
});

const router = new Router({
  routes
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/email-verified"];
  const isPublic = publicPages.includes(to.path);

  const loggedIn = store.getters["auth/isLogged"];

  const isVerified = store.getters["auth/emailVerified"];
  try {
    if (isPublic) {
      // Si la ruta es publica debe ir a la ruta

      return next();
    } else {
      // Si la ruta no es publica
      if (loggedIn) {
        if (isVerified) {
          // Si esta verificado el correo enviar a la ruta
          return next();
        } else {
          // Caso contrario enviar a la vista de email-verified
          return next({ path: "/email-verified" });
        }
        // Si esta loggeado el usuario ir a la ruta solicitada
      } else {
        // Si NO esta logueado debe ir al login
        return next({ path: "/login" });
      }
    }
  } catch (error) {
    console.error(error);
  }
});
router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});
export default router;
